<template>
  <div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">{{ $t("message.register_step1") }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">{{ $t("message.register_step2") }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">{{ $t("message.register_step3") }}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="mb-12" :color="this.$store.getters.stdColorLight" height="300px">
            <v-card-title class="subtitle-2">
              <span v-html="getInformationTitle()"></span>
            </v-card-title>
            <v-card-text>
              <span style="white-space: pre-line" v-html="getInformationText()"></span>
            </v-card-text>
          </v-card>

          <v-row>
            <v-col cols="1">
              <v-btn class="white--text" :color="this.$store.getters.stdColorDark" @click="nextStep(1)">{{ $t("message.continue") }}</v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn class="white--text" :color="this.$store.getters.stdColorDark" @click="cancel()">{{ $t("message.cancel") }}</v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card class="mb-12" :color="this.$store.getters.stdColorLight" height="400px">
            <v-card-title class="subtitle-2">
              <v-row justify="center">
                <span v-html="getStep2Title()"></span>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="4">
                    <v-text-field v-model="this.$store.getters.username" :disabled="true" :label="$t('user.mid')"></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="editedItem.nameFirma" :label="$t('user.nameFirma')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6">
                    <v-text-field v-model="editedItem.name" :label="$t('user.name')"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="editedItem.vorname" :label="$t('user.vorname')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <v-text-field v-model="editedItem.strasse" :label="$t('user.strasse')"></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <v-text-field v-model="editedItem.strasseNr" :label="$t('user.strasseNr')"></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="editedItem.plz" :label="$t('user.plz')"></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="editedItem.ort" :label="$t('user.ort')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6">
                    <v-text-field v-model="editedItem.telefonG" :label="$t('user.telefonG')"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>

          <v-row>
            <v-col cols="1">
              <v-btn class="white--text" :color="this.$store.getters.stdColorDark" :disabled="checkStep2()" @click="nextStep(2)">{{ $t("message.continue") }}</v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn class="white--text" :color="this.$store.getters.stdColorDark" @click="cancel()">{{ $t("message.cancel") }}</v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card class="mb-12" :color="this.$store.getters.stdColorLight" height="200px">
            <v-card-title class="subtitle-2">
              <span v-html="getStep3InformationTitle()"></span>
            </v-card-title>
            <v-card-text>
              <span style="white-space: pre-line" v-html="getStep3InformationText()"></span>
            </v-card-text>
          </v-card>

          <v-row>
            <v-col cols="1">
              <v-btn class="white--text" :color="this.$store.getters.stdColorDark" @click="registerEnd()">{{ $t("message.ok") }}</v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import WebService from "@/plugins/WebService";

export default {
  name: "optima-register",

  data: () => ({
    webService: null,

    editedItem: {
      username: '',
      password: '',
      accountNonExpired: true,
      accountNonLocked: true,
      credentialsNonExpired: true,
      enabled: true,
      roles: ['ROLE_USER'],
      mid: '',
      nameFirma: '',
      name: '',
      vorname: '',
      strasse: '',
      strasseNr: '',
      plz: '',
      ort: '',
      telefonG: '',
      mwstNummer: '',
      uid: '',
      admin: false
    },

    eMail: {
      recipient: "",
      subject: "",
      message: "",
      returnState: false,
      returnMessage: ""
    },

    e1: 1
  }),

  created() {
    this.webService=new WebService(this);
  },

  methods: {
    checkStep2()
    {
      var retVal=false;

      if (this.editedItem.name.length==0)
        retVal=true;
      if (this.editedItem.vorname.length==0)
        retVal=true;
      if (this.editedItem.strasse.length==0)
        retVal=true;
      if (this.editedItem.strasseNr.length==0)
        retVal=true;
      if (this.editedItem.plz.length<4)
        retVal=true;
      if (this.editedItem.ort.length==0)
        retVal=true;
      if (this.editedItem.telefonG.length<10)
        retVal=true;

      return retVal;
    },

    cancel()
    {
      this.$store.dispatch("setShowRegisterProcess", false);
    },

    nextStep(step)
    {
      this.e1 = step+1;

      if (this.e1==3)
      {
        this.editedItem.username=this.$store.getters.username
        this.editedItem.mid=this.$store.getters.username
        if (this.editedItem.nameFirma.length==0)
          this.editedItem.nameFirma="private"

        this.webService.insertUser(this.$store.getters.insertUser, this.editedItem)
          .then(response => {
            if (response.request.status==201)
            {
              if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
              {
                this.eMail.recipient = this.$store.getters.username;
                this.eMail.subject = this.$t("message.newPWSubject");
                this.eMail.message = this.$t("message.newPWMessage") + this.$t("message.mailText2");
                //send new password
                this.webService
                  .issueNewPassword(this.$store.getters.issueNewPassword, this.eMail)
                  .then(response => {
                    this.eMail = response.data;
                  })
                  // eslint-disable-next-line
                  .catch(err => {
                    this.eMail.returnMessage = "Mail: REST API Error";
                    this.eMail.returnState = false;
                  });
              }
              else
              {
                this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
              }
            }
          })
          .catch(err => { console.log(err) });

      }
    },

    registerEnd()
    {
      this.$store.dispatch("setShowRegisterProcess", false);
    },

    getInformationText()
    {
      return this.$t("message.register_informationText");
    },

    getInformationTitle()
    {
      return this.$t("message.register_informationTitle");
    },

    getStep2Title()
    {
      return this.$t("message.register_step2Title");
    },

    getStep3InformationTitle()
    {
      return this.$t("message.register_step3InformationTitle");
    },

    getStep3InformationText()
    {
      return this.$t("message.register_step3InformationText");
    }
  }

};
</script>

<style scoped>
</style>
